module.exports = __webpack_public_path__ + "static/media/squared.b71e1cc3.jpg";